import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Tooltip, Button, Modal, Divider, message } from "antd";
import {QuestionCircleOutlined, CloseOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { format, findDeep, getRulesDetail } from "@/utils";
import api from "@/api";
import { publicPath } from "@/utils/base";

const { confirm } = Modal;
import dataJson from "@/../public/data.json";

const prefix = "rulesDetail-info";
import "./index.less";

function Info() {
  const { rules_detail, confirmText, cancelText, release, delete_text } = dataJson;

  const [rulesLication, setRulesLication] = useState<any>();

  const navigate = useNavigate();
  const { id } = useParams();

  const rulesDetail = useSelector((state: any) => state.rulesDetail);

  const handleDelete = () => {
    confirm({
      title: delete_text + rules_detail?.detail_title,
      icon: null,
      width: 480,
      centered: true,
      closable: true,
      closeIcon: <CloseOutlined />,
      okText: confirmText,
      cancelText: cancelText,
      content: (
        <div className="delete-modal-content">
          <ExclamationCircleOutlined style={{color:"red", marginRight:"4px"}}/>
          {rules_detail.app_delete_content1}&quot;{rulesLication.name}&quot;
          {rules_detail.app_delete_content2}
        </div>
      ),
      onOk: async () => {
        try {
          const res: any = await api.deleteRuleDataApi({ ids: [id] });

          if (res?.code == 200) {
            navigate(`${publicPath}/rules_list`);
          } else {
            message.error(res.msg);
          }
        } catch (errorInfo: any) {
          console.error(errorInfo);
        }
      },
    });
  };

  useEffect(() => {
    if (rulesDetail) {
      const firstTwo = rulesDetail.histories.slice(0, 2);
      const isDel = firstTwo.every((item: any) => {
        const resShowMode = findDeep(release.show_mode_arr, item.showMode);
        return resShowMode?.baseBtns?.includes("delete");
      });

      const resDataCopy = {
        ...rulesDetail,
        createTimeText: format(new Date(Number(rulesDetail?.createTime)), "yyyy年MM月dd日 HH:mm:ss"),
        isDel,
      };

      setRulesLication(resDataCopy);
    }
  }, [rulesDetail]);

  useEffect(() => {
    getRulesDetail(id);
  }, [id]);

  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-header`}>
          <div className={`${prefix}-header-text`}>
            <div className={`${prefix}-header-title`}>{rules_detail.detail_title_text}</div>
            <div className={`${prefix}-header-tip`}>{rules_detail.detail_title + rules_detail.info_tip}</div>
          </div>
          <div className={`${prefix}-header-btns`}>
            <Button
              className={`${prefix}-content-delete`}
              disabled={!rulesLication?.isDel}
              onClick={handleDelete}
            >
              {delete_text}
            </Button>
          </div>
        </div>
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-content-title`}>{rules_detail.developer_title}</div>
          <div className={`${prefix}-content-developer`}>
            <Tooltip
              placement="bottomLeft"
              title={rules_detail.developer_tip}
              overlayClassName={`${prefix}-content-developer-tooltip`}
              color="#fff"
              overlayInnerStyle={{
                color: "rgba(0,0,0,0.8)",
                width: 200,
                padding: "10px 16px",
                transform: "translate(-12px, 0)",
              }}
            >
              <QuestionCircleOutlined style={{ color: "#0A59F7", cursor: "pointer", fontSize: 14 }} />
            </Tooltip>
            <div className={`${prefix}-content-developer-id`}>
              <span>{rules_detail.developer_ID}</span>
              {rulesLication?.developerId}
            </div>
          </div>
          <Divider />
          <div className={`${prefix}-content-title mt-title`}>{rules_detail.detail_title}</div>
          <div className={`${prefix}-content-value`}>
            <span>{rules_detail.business_rules_ID}</span>
            {rulesLication?.id}
          </div>
          <div className={`${prefix}-content-value`}>
            <span>{rules_detail.create_time}</span>
            {rulesLication?.createTimeText}
          </div>
          <div className={`${prefix}-content-value`}>
            <span>{rules_detail.template_name}</span>
            <Link to={`${publicPath}/super_device_template_detail/info/${rulesLication?.superModelId}`} style={{color:'#0a59f7'}}>{rulesLication?.superModelName}</Link>
          </div>

          <Divider />
          <div className={`${prefix}-content-title mt-title`}>{rules_detail.development_kit}</div>
          <div className={`${prefix}-content-value`}>
            <span>{rules_detail.tool}</span>
            <Link to={rulesDetail?.editorUrl} target="_blank" style={{color:'#0a59f7'}}>{rules_detail.tool_link_text}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Info;
